import request from '@/utils/request'

export function getWechatSandboxSignKey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/payment.getWechatSandboxSignKey',
      method: 'post',
      data: data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function savePaymentSandbox(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/paymentSandbox.savePaymentSandbox',
      method: 'post',
      data: data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getPaymentSandbox(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/paymentSandbox.getPaymentSandbox',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
